import type { LocationPageHeaderProps } from "./location-page-header.type";

import BaseHeader from "@/components/Header/BaseHeader";
import HeaderButtons from "@/components/Header/Location";
import LocationBreadcrumb from "@/modules/location/location-breadcrumb";

const LocationPageHeader = ({ location, loading }: LocationPageHeaderProps) => {
  return (
    <BaseHeader
      title={location?.name}
      breadcrumb={<LocationBreadcrumb location={location} />}
      loading={loading}
      extra={
        !loading
          ? [<HeaderButtons key="HeaderButtons" location={location} />]
          : []
      }
    />
  );
};

export default LocationPageHeader;
